import React, { useEffect, useState } from "react";
import SmallComponentHeading from "../../components/Headings/SmallComponentHeading";
import Button from "../../components/Button";
import { ReactComponent as EditSvg } from "../../assets/svg/edit.svg";
import { ReactComponent as PlusSquareSvg } from "../../assets/svg/plus_square.svg";
import "../../css/my-dinosaurs.css";
import ComponentContainer from "../../components/ComponentContainer";
import UserMenu from "../../components/UserMenu/UserMenu";
import MegaCommon from "../../components/MegaProfile/MegaCommon";
import Modal from "../../components/Modal";
import DinosaurCard from "../../components/DinosaurCard";
import {
  dinosaurSizes,
  dinosaurTypes,
  initialCookieOptions,
  megaShopTypes,
  pageNames,
} from "../../utils/consts";
import { usePageName } from "../../hooks/usePageName";
import userStore from "../../store/userStore";
import { v4 as uuidv4 } from "uuid";
import { useCookies } from "react-cookie";
import UserDinosaurAbout from "../../components/Dinosaur/UserDinosaurAbout";
import userInventory from "../../store/userInventory";
import { showModal } from "../../helperComponents/ModalWrapper";
import storageApi from "../../api/storageApi";
import { apiHelpers } from "../../utils/apiHelpers";
import {
  catalogItemTypes,
  legacyCatalogCategoriesEng,
} from "../../utils/megaShopItemsData";
import { observer } from "mobx-react-lite";
import { fetchWithAbort } from "../../utils/fetchWithAbort";

const MyDinosaurs = () => {
  const [cookie, setCookie, removeCookie] = useCookies();

  usePageName(pageNames.MegaProfile);
  const [userDinosaurs, setUserDinosaurs] = useState([]);
  const [storageItems, setStorageItems] = useState(userStore.storage || []);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      try {
        await fetchWithAbort(
          (signal) => apiHelpers.getAndSetUserStorage(0, signal),
          signal
        );
      } catch (err) {
        console.error(err);
      }
    })();

    return () => {
      controller.abort();
    };
  }, []); // с dependencies зависает wordPress т.к. бесконечно обновляет куки

  useEffect(() => {
    setStorageItems(userStore.storage);
  }, [userStore.storage]);

  useEffect(() => {
    setUserDinosaurs(
      userStore.storage.filter(
        (item) => item.shopItem.type === catalogItemTypes.dinosaurs
      )
    );
  }, [storageItems]);

  const starterDinosaursData = [
    // {
    //   image: dinosaurImg1,
    //   tier: "2",
    //   name: "НАИМЕНОВАНИЕ",
    //   type: dinosaurTypes.herbivorous,
    // },
    // {
    //   image: dinosaurImg2,
    //   tier: "2",
    //   name: "НАИМЕНОВАНИЕ",
    //   type: dinosaurTypes.herbivorous,
    // },
    // {
    //   image: dinosaurImg3,
    //   tier: "2",
    //   name: "НАИМЕНОВАНИЕ",
    //   type: dinosaurTypes.herbivorous,
    // },
    // {
    //   image: dinosaurImg4,
    //   tier: "2",
    //   name: "НАИМЕНОВАНИЕ",
    //   type: dinosaurTypes.herbivorous,
    // },
  ];
  const [isModalVisible, setIsModalVisible] = useState(false);

  // Пока отключить
  function openModal() {
    // setIsModalVisible(true);
  }

  function closeModal() {
    setIsModalVisible(false);
  }

  async function chooseDinosaur(dinosaurData, onClose) {
    if (userDinosaurs.length >= 3) return;
    setUserDinosaurs([...userDinosaurs, dinosaurData]);
    setIsModalVisible(false);
    onClose();
  }

  useEffect(() => {
    if (isModalVisible) {
      const { onClose } = showModal({
        onClose: closeModal,
        children: (
          <>
            <SmallComponentHeading>
              ВЫБЕРИТЕ НАЧАЛЬНОГО ДИНОЗАВРА
            </SmallComponentHeading>
            <div className="flex-container">
              {starterDinosaursData.map((data, i) => (
                <div className="flex-item" key={`starter-dinosaurs-${i}`}>
                  <DinosaurCard data={data.shopItem} size={dinosaurSizes.big} />
                  <Button
                    className="no-background border-extra"
                    onClick={() => chooseDinosaur(data, onClose)}
                  >
                    Выбрать
                  </Button>
                </div>
              ))}
            </div>
          </>
        ),
      });
    }
  }, [isModalVisible]);

  return (
    <>
      <div className="my-dinosaurs-page page mega-profile-page">
        <MegaCommon>
          <div className="my-dinosaurs">
            <SmallComponentHeading className="flex svg-text">
              <span>Мои динозавры</span>
              <div className="buttons">
                <Button className="no-background border-extra spiked">
                  <EditSvg /> редактировать
                </Button>
                <Button className="no-background border-extra spiked">
                  <PlusSquareSvg /> КУПИТЬ ДИНОЗАВРОВ
                </Button>
              </div>
            </SmallComponentHeading>
            <div className="my-dinosaurs-container">
              {userDinosaurs.length > 0 &&
                userDinosaurs.map((dinosaurData, i) => (
                  <div className="item" key={`user-dinosaurs-high-${i}`}>
                    <DinosaurCard
                      data={dinosaurData.shopItem}
                      size={dinosaurSizes.big}
                    />
                    <UserDinosaurAbout
                      data={dinosaurData /*testDinosaurData*/}
                    />
                  </div>
                ))}
              {userDinosaurs.length < 3 &&
                Array(3 - userDinosaurs.length)
                  .fill()
                  .map((_, index) => (
                    <div
                      key={`user-dinosaurs-low-${index}`}
                      className="empty-card background-accent-black"
                    >
                      <div className="card-body">
                        <p>
                          <b>Пустой слот</b>
                        </p>
                        <p>Вы можете зайти в игру и выбрать динозавра</p>
                        <Button
                          className="no-background border-extra spiked"
                          onClick={openModal}
                        >
                          АКТИВИРОВАТЬ СЛОТ
                        </Button>
                      </div>
                    </div>
                  ))}
              <div className="empty-card gradient-background extra buy-slot">
                <div className="card-body">
                  <p>
                    <b>Купить слот</b>
                  </p>
                  <p>Вы можете зайти в игру и выбрать динозавра</p>
                  <Button className="no-border gradient-background extra spiked">
                    КУПИТЬ СЛОТ
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </MegaCommon>
      </div>
    </>
  );
};

export default observer(MyDinosaurs);
